import { render, staticRenderFns } from "./Popup-info.vue?vue&type=template&id=018cdfce&"
import script from "./Popup-info.vue?vue&type=script&lang=ts&"
export * from "./Popup-info.vue?vue&type=script&lang=ts&"
import style0 from "./Popup-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports